import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Form, Input, Button } from 'semantic-ui-react';
import i18next from 'i18next';
import { editEntityField, saveWebsite } from '../../../actions';
import { withRouter } from 'react-router-dom';

class WebsiteAccessKeyEditor extends Component {
    handleSubmit = (event) => {
        const { entity: wak, websiteId } = this.props;

        const website = { id: websiteId, [!wak.id ? 'accessKeysToAdd' : 'accessKeysToUpdate']: [wak] };

        this.props.saveWebsite(website);
        event.preventDefault();
    }

    render() {
        const { entity } = this.props;

        const wak = entity || {};

        return (
            <Form onSubmit={this.handleSubmit}>
                <Form.Field>
                    <label>{i18next.t('website.accessKey')}</label>
                    <Input
                        fluid
                        placeholder={i18next.t('website.accessKey')}
                        value={wak.accessKey || ''}
                        onChange={({ target }) => this.props.editEntityField('accessKey', target.value)}
                    />
                </Form.Field>

                <Form.Field>
                    <label>{i18next.t('tableNumber')}</label>
                    <Input
                        fluid
                        placeholder={i18next.t('tableNumber')}
                        value={wak.tableNumber || ''}
                        onChange={({ target }) => this.props.editEntityField('tableNumber', target.value)}
                    />
                </Form.Field>

                <Button primary type='submit' floated="right">
                    {i18next.t('save')}
                </Button>
            </Form>
        );
    }
}

WebsiteAccessKeyEditor.propTypes = {
    saveWebsite: PropTypes.func,
    editEntityField: PropTypes.func,
    entity: PropTypes.object,
    websiteId: PropTypes.any,
};

const mapStateToProps = (state) => {
    const { entity } = state.editor;

    return { entity };
};

export default connect(mapStateToProps, {
    saveWebsite,
    editEntityField,
})(withRouter(WebsiteAccessKeyEditor));
